import { create } from "zustand";

/**
 * 酒店预订日期状态管理
 *
 * 职责：在酒店详情页与填写订单页之间跳转时，保持用户已选择的入住/离店日期。
 * 组件卸载后（如跳转到订单页）state 会重置，因此用模块级 store 记住日期，
 * 返回详情页时恢复，而不是回退到默认的「当天 + 第二天」。
 */
interface HotelBookingState {
  /** 当前日期所属的酒店 ID */
  hotelId: number | null;
  /** 入住日期（YYYY-MM-DD HH:mm） */
  checkIn: string | null;
  /** 离店日期（YYYY-MM-DD HH:mm） */
  checkOut: string | null;

  /** 保存某个酒店的日期选择 */
  saveDates: (hotelId: number, checkIn: string, checkOut: string) => void;
}

export const useHotelBookingStore = create<HotelBookingState>((set) => ({
  hotelId: null,
  checkIn: null,
  checkOut: null,

  saveDates: (hotelId, checkIn, checkOut) =>
    set({ hotelId, checkIn, checkOut }),
}));
